import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageCases = lazy(() => import("./layout/index"));

export const routerPageCases: RouterItemType = {
  path: "/support/cases",
  authorize: true,
  element: <LayoutPageCases />,
};
